import React from 'react';
import { Droplets } from 'lucide-react';
import { Trans, useTranslation } from 'react-i18next';
import './WaterSummary.css';

export function WaterSummary({ 
  rainfall, 
  etCampo, 
  etRetro, 
  periodLabel 
}) {
  const { t } = useTranslation();
  const waterSaved = etCampo - etRetro;
  const percentSaved = etCampo > 0 ? ((waterSaved / etCampo) * 100).toFixed(1) : 0;

  return (
    <div className="water-summary">
      <div className="water-summary__header">
        <Droplets size={24} className="water-summary__icon" />
        <h3 className="water-summary__title">{t('analytics.waterSummary.title')}</h3>
      </div>
      
      <p className="water-summary__period">{t('analytics.waterSummary.period', { period: periodLabel })}</p>
      
      <div className="water-summary__table">
        <div className="water-summary__row">
          <span className="water-summary__label">{t('analytics.waterSummary.totalRainfall')}</span>
          <span className="water-summary__value">{rainfall.toFixed(1)} mm</span>
        </div>
        <div className="water-summary__row">
          <span className="water-summary__label">
            {t('analytics.waterSummary.cropEtWithType', { type: t('stations.types.field') })}
          </span>
          <span className="water-summary__value">{etCampo.toFixed(1)} mm</span>
        </div>
        <div className="water-summary__row">
          <span className="water-summary__label">
            {t('analytics.waterSummary.cropEtWithType', { type: t('stations.types.underpanel') })}
          </span>
          <span className="water-summary__value">{etRetro.toFixed(1)} mm</span>
        </div>
      </div>
      
      <div className="water-summary__result">
        <div className="water-summary__saved">
          <div className="water-summary__saved-icon-wrapper">
            <Droplets size={24} className="water-summary__saved-icon" />
          </div>
          <div className="water-summary__saved-content">
            <span className="water-summary__saved-label">{t('analytics.waterSummary.waterSaved')}</span>
            <span className="water-summary__saved-value">
              {t('analytics.waterSummary.waterSavedValue', { mm: waterSaved.toFixed(1), percent: percentSaved })}
            </span>
          </div>
        </div>
      </div>
      
      <p className="water-summary__note">
        <strong>{t('analytics.waterSummary.calculationLabel')}:</strong>{' '}
        <Trans i18nKey="analytics.waterSummary.calculationFormula">
          ET<sub>field</sub> - ET<sub>under</sub> = water saved.
        </Trans>{' '}
        {t('analytics.waterSummary.calculationExplanation')}
      </p>
    </div>
  );
}

